/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { filterDomProps } from "common/vue/filter-dom-props";
import { useVueProps, vueDefaultFactory, vueDefaultValue } from "common/vue/useVueProps";
/* eslint-disable max-lines-per-function */
import { remoteImageStaticUrl } from "common/utils/remote-image";
import Tooltip from "common/vue/components/Tooltip.react.vue";
import "./StoreCreditTiers.react.scss";
import { renderList } from "common/vue/render-list";
import { useI18n } from "intl/useI18n";
import InfoCircleBoldIcon from "assets/icons/info-circle-bold.svg";

// @ts-ignore TS(6133): 'rawProps' is declared but its value is never read... Remove this comment to see the full error message
function getDefaultProps(rawProps: any) {
  return {
    expectedCredits: vueDefaultValue(null),
    totalAmount: vueDefaultValue(null),
    currentTier: vueDefaultValue(null),
    tiers: vueDefaultFactory(() => []),
    isTooltip: vueDefaultValue(false)
  };
}

export default function StoreCreditTiers(rawProps: any) {
  const { className, expectedCredits, totalAmount, currentTier, tiers, isTooltip, ...restProps } =
    rawProps;

  const props = useVueProps(rawProps, getDefaultProps);
  const { n } = useI18n();

  function loyaltyBadgeUrl() {
    return remoteImageStaticUrl("gen/loyalty-badge.png");
  }

  function filteredTiers() {
    return props.current.tiers.filter((tier: any) => tier.percentage > 0);
  }

  function nextTier() {
    return (
      props.current.tiers.find(
        (tier: any) => props.current.totalAmount > 0 && props.current.totalAmount < tier.min
      ) || null
    );
  }

  function amountToNextTier() {
    if (nextTier()) {
      return nextTier().min - props.current.totalAmount;
    }
    return 0;
  }

  function maxPercentage() {
    if (!props.current.tiers?.length) return 0;
    return Math.max(...props.current.tiers.map((tier: any) => tier.percentage));
  }

  return (
    <div
      // @ts-ignore TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      {...filterDomProps(restProps)}
      className={cn(
        [
          "store-credit-tiers scope-045e67ae",
          {
            "store-credit-tiers--tooltip": props.current.isTooltip
          }
        ],

        className
      )}
    >
      {!props.current.isTooltip ? (
        <div className={cn("store-credit-tiers__header", "scope-045e67ae")}>
          <img
            className={cn("store-credit-tiers__icon", "scope-045e67ae")}
            alt="Loyalty Badge"
            src={loyaltyBadgeUrl()}
          />

          <p className={cn("store-credit-tiers__text", "scope-045e67ae")}>
            {props.current.expectedCredits > 0 ? (
              <span className={cn("scope-045e67ae")}>
                {" "}
                You'll earn{" "}
                <strong className={cn("scope-045e67ae")}>
                  {n(props.current.expectedCredits, "currency")} credit
                </strong>{" "}
                on Transfers!{" "}
              </span>
            ) : (
              <span className={cn("scope-045e67ae")}> Earn credits on Transfers! </span>
            )}
          </p>
        </div>
      ) : null}
      <div className={cn("store-credit-tiers__progress", "scope-045e67ae")}>
        {nextTier() ? (
          <p className={cn("store-credit-tiers__progress-text", "scope-045e67ae")}>
            {" "}
            You're{" "}
            <strong className={cn("scope-045e67ae")}>
              {n(amountToNextTier(), "currency")}
            </strong>{" "}
            away from <strong className={cn("scope-045e67ae")}>{nextTier().percentage}%</strong>{" "}
            store credit.{" "}
          </p>
        ) : (
          <p className={cn("store-credit-tiers__progress-text", "scope-045e67ae")}>
            {" "}
            You've earned{" "}
            <strong className={cn("scope-045e67ae")}>
              {props.current.currentTier?.percentage || 0}%
            </strong>{" "}
            store credit!{" "}
          </p>
        )}
        {!props.current.isTooltip ? (
          <Tooltip
            className={cn("scope-045e67ae")}
            trigger="click"
            position="top-right"
            slots={{
              target: () => (
                <InfoCircleBoldIcon
                  className={cn("store-credit-tiers__info-icon", "scope-045e67ae")}
                  data-testid="store-credit-tiers-info-icon"
                />
              ),

              content: () => (
                <div className={cn("store-credit-tiers__tooltip", "scope-045e67ae")}>
                  {" "}
                  Earn up to {maxPercentage()}% back on every purchase!{" "}
                  <a
                    className={cn("scope-045e67ae")}
                    href="/transfer-rewards-terms-conditions"
                    data-testid="store-credit-tiers-a"
                  >
                    Terms and Conditions
                  </a>
                </div>
              )
            }}
            data-testid="tooltip"
          />
        ) : null}
      </div>
      <div className={cn("store-credit-tiers__tiers", "scope-045e67ae")}>
        {renderList(filteredTiers(), (tier, index) => (
          <div
            className={cn("store-credit-tiers__tier scope-045e67ae", {
              "store-credit-tiers__tier--active":
                props.current.currentTier.percentage === tier.percentage
            })}
            key={index}
          >
            <span className={cn("store-credit-tiers__tier-rate", "scope-045e67ae")}>
              {tier.percentage}%
            </span>
            <span className={cn("store-credit-tiers__tier-range", "scope-045e67ae")}>
              {tier.range}
            </span>
          </div>
        ))}
      </div>
      {props.current.isTooltip ? (
        <a
          className={cn("store-credit-tiers__link", "scope-045e67ae")}
          href="/transfer-rewards-terms-conditions"
          data-testid="store-credit-tiers-link"
        >
          {" "}
          Terms and Conditions{" "}
        </a>
      ) : null}
    </div>
  );
}
